// extracted by mini-css-extract-plugin
export default {"meatball":"user-toolbar__meatball--Yj3gH","not-allowed":"user-toolbar__not-allowed--HPK7I","notAllowed":"user-toolbar__not-allowed--HPK7I"};